import * as broker from './broker';
import * as arrayUtil from './arrayUtils';
import { postData } from './http';

const url = '/api2/urgencymessaging/';
const cache = {};
let promise;

if (TRPCONFIG.Domain.UrgencyMessaging) {
    broker.subscribe('urgencyMessaging', 'hotelsReturnedFromSearch', function(e) {
        promise = _get(arrayUtil.map(arrayUtil.filter(e.data, function(hotel) {
            return cache[hotel.Id] == null;
        }), hotel => hotel.Id));
    });
}

function _get(estabIds) {
    if (!_.get(estabIds, '[0]')) {
        return Promise.resolve();
    }

    const fields = 'EstabId,CurrentViewsText,LastBookedDateText,ShortlistCountText';
    const req = {
        EstabIds: estabIds,
        CultureCode: TRPCONFIG.Domain.CultureCode,
        DomainId: TRPCONFIG.Domain.DomainId
    };

    return postData(`${url}getestabstats?fields=${fields}`, req, { logErrors: false })
        .then(function(data) {
            angular.forEach(data, function(d) {
                cache[d.EstabId] = d;
            });
        });
}

export function get(estabId) {
    if (promise == null) {
        return _get([estabId]).then(function() {
            return cache[estabId];
        });
    }
    return promise.then(function() {
        return cache[estabId];
    });
}

export function getUrl() {
    return url;
}
